import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import requester from '@/lib/axios';
import { QuestionCreateDTO, PositionalAnswerCreateDTO } from '@/models/Answer';
import { FlowColumn, PositionalColumn } from '@/models/Question';
import { jsonToFormData } from '@/utils/shared/jsonToFormData';

const baseUrl = 'dnd-positional-column';

type PositionalItemPayload = QuestionCreateDTO | PositionalAnswerCreateDTO;

type ColumnUpdatePayload = {
  flow?: FlowColumn;
  items?: PositionalItemPayload[];
};

export const updatePositionalColumn = async (
  id: number,
  changes: ColumnUpdatePayload,
) => {
  const formData = jsonToFormData(changes);
  const { data } = await requester().patch<PositionalColumn>(
    `${baseUrl}/${id}/`,
    formData,
    { headers },
  );
  return data;
};
